module.exports = __webpack_public_path__ + "static/magic-logo-hover-efe88eab30d7895c89254ac6dd497fc8.png";